import React, { lazy } from 'react';
import { Star, Lock, MailIcon } from 'lucide-react';
export function HeroSection() {
  return <section className="pt-24 pb-10 px-4 md:pt-24 md:pb-10 bg-brand-cream overflow-hidden" data-id="element-143">
      <div className="max-w-7xl mx-auto" data-id="element-144">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 lg:gap-12 items-start" data-id="element-145">
          {/* Image — left on desktop, below text on mobile */}
          <div className="order-2 lg:order-1 w-full max-w-md mx-auto lg:max-w-none animate-fade-in-up animation-delay-200" data-id="element-146">
            <img src="https://cdn.magicpatterns.com/uploads/hePuczFGhWAEUCK9fSoHun/ChatGPT_Image_Mar_14,_2026,_12_18_13_AM.webp" alt="Panadería Artesanal Sin Gluten — Pack de ebooks y recetas" className="w-full max-w-[485px] h-auto rounded-2xl shadow-xl mx-auto" width={485} height={485} decoding="async" fetchPriority="high" data-id="element-147" />
            <p className="text-lg md:text-xl text-brand-brownLight leading-relaxed text-center mt-4" data-id="element-148">
              <span className="text-brand-terracotta font-bold" data-id="element-149">
                Más de 160 recetas
              </span>{' '}
              probadas que funcionan desde el primer intento
            </p>
          </div>

          {/* Text Content — right on desktop, first on mobile */}
          <div className="flex flex-col gap-3 md:gap-6 order-1 lg:order-2 animate-fade-in-up" data-id="element-150">
            <div className="text-center lg:text-left" data-id="element-151">
              <p className="font-heading italic text-brand-brownLight text-xl md:text-2xl mb-2" data-id="element-152">
                Chef Alessandra Mora
              </p>
              <h1 className="font-heading font-bold text-brand-brown text-3xl md:text-4xl lg:text-5xl leading-tight uppercase" data-id="element-153">
                DOMINA LA{' '}
                <span className="text-brand-terracotta" data-id="element-154">
                  COCINA SIN GLUTEN{' '}
                </span>
                EN 7 DÍAS
              </h1>
              <p className="mt-3 text-sm md:text-base font-bold tracking-[0.2em] text-brand-brown uppercase" data-id="element-155">
                SIN GLUTEN - SIN AZÚCAR - SIN LACTOSA
              </p>
            </div>
          </div>
        </div>

        <div className="mt-6 flex flex-col items-center gap-3 md:gap-4 animate-fade-in-up animation-delay-200" data-id="element-156">
          <button onClick={() => {
          const scrollToOferta = () => {
            const el = document.getElementById('oferta');
            if (el) {
              el.scrollIntoView({
                behavior: 'smooth'
              });
              return;
            }
            // Element not yet in DOM — scroll down to trigger ViewportGate
            window.scrollBy({
              top: window.innerHeight,
              behavior: 'smooth'
            });
            setTimeout(scrollToOferta, 400);
          };
          scrollToOferta();
        }} className="group relative flex items-center justify-center gap-3 bg-brand-terracotta hover:bg-brand-terracottaHover text-white text-lg md:text-xl font-bold py-4 px-8 rounded-xl shadow-[0_8px_20px_rgba(196,93,44,0.3)] transition-all hover:-translate-y-1 w-full sm:max-w-md cursor-pointer" data-id="element-157">
            ¡QUIERO EL COMBO 3×1 AHORA! ➤
          </button>

          <div className="flex flex-wrap items-center justify-center gap-4 text-sm font-medium text-brand-brownLight" data-id="element-158">
            <span className="flex items-center gap-1" data-id="element-159">
              <MailIcon className="w-4 h-4 text-brand-green" data-id="element-160" /> Acceso Inmediato
              al Email
            </span>
            <span className="hidden sm:inline" data-id="element-161">•</span>
            <span className="flex items-center gap-1" data-id="element-162">
              <Lock className="w-4 h-4 text-brand-green" data-id="element-163" /> Compra 100% Segura
            </span>
            <span className="hidden sm:inline" data-id="element-164">•</span>
          </div>

          {/* Social proof badge */}
          <div className="flex justify-center animate-fade-in-down" data-id="element-165">
            <div className="flex items-center gap-2 bg-brand-sage w-fit px-3 py-1 rounded-full text-brand-green text-sm font-bold" data-id="element-166">
              <div className="flex" data-id="element-167">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-current" data-id="element-168" />)}
              </div>
              <span data-id="element-169">Más de 2,400 alumnas satisfechas</span>
            </div>
          </div>
        </div>

        {/* Before/After image */}
        <div className="mt-8 flex justify-center animate-fade-in-up animation-delay-200" data-id="element-170">
          <img src="https://cdn.magicpatterns.com/uploads/1jTJ1tfKsdf96TngrZZUQJ/ChatGPT_Image_Mar_13,_2026,_11_37_35_PM_(2).webp" alt="Antes y después — de pan seco y sin sabor a pan artesanal perfecto sin gluten" className="w-full max-w-lg rounded-2xl shadow-xl" loading="lazy" data-id="element-171" />
        </div>
      </div>
    </section>;
}